export default "__VITE_ASSET__CHJKWEcR__"